
import TopMenu from '../TopMenu/TopMenu';
import Visualizer from '../Visualizer/Visualizer';

import EmailShareModal from '../EmailShareModal/EmailShareModal';
import MoreInfoModal from '../MoreInfoModal/MoreInfoModal';
import MarketingModal from '../MarketingModal/MarketingModal';

import styles from './VisualizerPage.module.css';
import PackagesList from '../PackagesList/PackagesList';
import PackageItems from '../PackageItems/PackageItems';

export default function VisualizerPage() {


    return (
        <>
            <TopMenu extended={true} />
            <section className={styles.visualizerView}>
                <div className={styles.content}>
                    <div className={styles.prodGroup}>
                        <div className={styles.packageColumn}>
                            <PackagesList/>
                        </div>
                        <div className={styles.productsColumn}>
                            <PackageItems/>
                        </div>
                        </div>
                        <div className={styles.centerColumn}>
                            <Visualizer />
                        </div>
                </div>
            </section>
            <EmailShareModal />
            <MoreInfoModal />
            <MarketingModal/>
        </>
    );
}